module.exports = __webpack_public_path__ + "img/konrad_schutz.456afca6.png";